import { useEffect, useRef } from 'react';
import { v4 as uuid } from 'uuid';

export const DigitalHuman = ({
  canUseDigitalHuman,
  digitalHumanReady,
  init,
  playStreamAddr,
}: {
  canUseDigitalHuman: boolean;
  digitalHumanReady: boolean;
  init: (params: any) => void;
  playStreamAddr: string;
}) => {
  const ReqId = uuid().replaceAll('-', ''); //单次请求唯一标识，长度为32的 uuid
  const UserId = uuid().replaceAll('-', ''); //需要生成一个新的，使用同一个userid会导致上一个用户被关闭

  // const ReqId = 'f2612aa810014e8997f95bda97917268';
  // const UserId = 'f2612aa810014e8997f95bda97917268';

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    init({
      _reqId: ReqId,
      _userId: UserId,
    });
  }, []);

  useEffect(() => {
    if (!digitalHumanReady || !playStreamAddr) return;
    const options = {
      autoplay: true,
      sources: playStreamAddr,
      controlBar: {
        progressControl: false,
      },
      // nativeControlsForTouch:true,
      webrtcConfig: {
        connectTimeout: 1,
        enableAbr: true,
        // showLog: true,
      },
      language: 'en',
    };
    const tcplayer = new TCPlayer('webrtc-player', options);
    tcplayer.on('debug', function (event) {
      // onPlayStats(event.data);
      console.log('webrtcevent: ', event.data.message);
    });
    tcplayer.on('webrtcInstanceCreated', function (event) {
      // const webrtcInstance = event.data.webrtc;
    });

    tcplayer.on('webrtcstats', function (event) {
      // onPlayStats(event.data);
    });
  }, [digitalHumanReady]);

  // 有点击操作，则解除静音
  useEffect(() => {
    const handleUserInteraction = () => {
      if (videoRef.current) {
        videoRef.current.muted = false;
      }
      document.removeEventListener('click', handleUserInteraction);
    };
    document.addEventListener('click', handleUserInteraction);

    return () => {
      document.removeEventListener('click', handleUserInteraction);
    };
  }, []);

  return (
    <div className="player-wrap">
      {canUseDigitalHuman ? (
        <video
          ref={videoRef}
          id="webrtc-player"
          width={458}
          autoPlay
          muted
          preload="auto"
          playsInline
          webkit-playsinline="true"
        />
      ) : null}
    </div>
  );
};
